'use client';

import { get as _get } from 'lodash-es';
import { useSuspenseQuery, useApolloClient } from '@apollo/client/react';
import { makeStyles } from 'tss-react/mui';
import Main from '@/components/main';
import NotFound from '@/components/not-found';
import EventCalendar from '@/components/dynamic-event-calendar';
import { cityCalendarQuery, cityCalendarEventsQuery } from '@/apollo/cities';
import CalendarLayout from '@/components/calendar/calendar-layout';
import CalendarSidebar from '@/components/calendar/sidebar';
import CalendarFooter from '@/components/calendar/footer';

const useStyles = makeStyles()((theme) => ({
  calendar: {
    margin: theme.spacing(2, 0),
  },
}));

export default function CalendarGridPageContent({ citySlug, bannerDismissed }: { citySlug: string; bannerDismissed: boolean }) {
  const { classes } = useStyles();
  const client = useApolloClient();

  const { data: cityData } = useSuspenseQuery(cityCalendarQuery, {
    variables: {
      slug: citySlug,
    },
  });
  const city = _get(cityData, 'city');

  function handleLoadEvents({ start, end }) {
    return client.query({
      query: cityCalendarEventsQuery,
      variables: {
        id: city.id,
        start,
        end
      }
    }).then(({ data }) => data.city.calendarEvents);
  }

  if (!city) { return <NotFound />; }

  return (
    <Main signupBanner bannerDismissed={bannerDismissed}>
      <CalendarLayout sidebar={<CalendarSidebar cityId={city.id} view="grid" />}>
        <div className={classes.calendar}>
          <EventCalendar timeZone={city.timezone} loadEvents={handleLoadEvents} />
        </div>

        <CalendarFooter />
      </CalendarLayout>
    </Main>
  );
}
